/* eslint-disable @typescript-eslint/no-explicit-any */
import { Button, Col, Form, Row } from "antd";
import { SelectField } from "../../../../../atoms/FormFields";
import { TimePickerField } from "../../../../../atoms/FormFields/TimePickerField";
import { CrewYardTableType } from "../../../../CompanySettings/CrewYards/ducks/types";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { changeStartOrEndPoint } from "../../../ducks/services";
import dayjs from "dayjs";
import { useAppDispatch } from "../../../../../config/hooks";
import { getScheduleByDay } from "../../../ducks/actions";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../../atoms/Toasts/ErrorMessage";

const CrewYard = ({
  crewYardListing,
  onCloseHandler,
  scheduleId,
  isStartPoint,
  selectedDate,
  setLoading,
}: {
  crewYardListing: CrewYardTableType[] | null;
  onCloseHandler: () => void;
  scheduleId?: any;
  isStartPoint?: boolean;
  selectedDate: any;
  setLoading: any;
}) => {
  const [crewYardDropOptions, setCrewYardDropOptions] = useState<
    { label: string; value: string }[]
  >([]);

  const dispatch = useAppDispatch();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (val: any) => {
    setLoading(true);
    const timeStr = val?.allocatedTime?.format("HH:mm");
    let decimalHours = 0;
    if (timeStr) {
      const [h, m] = timeStr.split(":").map(Number);
      decimalHours = h * 60 + m;
    }
    const crewYardData = crewYardListing?.find(
      (yard) => yard.id === val?.crewYardName
    );

    let payload = {};
    if (isStartPoint) {
      payload = {
        schedule_id: scheduleId ?? undefined,
        starting_point: "CREW_YARD",

        starting_crew_yard_id: val?.crewYardName,
        starting_crew_yard_name: crewYardData?.name,
        starting_point_duration: decimalHours,
        is_changing_start_point: isStartPoint,
        starting_crew_yard_latitude: crewYardData?.latitude || "",
        starting_crew_yard_longitude: crewYardData?.longitude || "",
      };
    } else {
      payload = {
        schedule_id: scheduleId ?? undefined,
        finish_point: "CREW_YARD",

        finish_crew_yard_id: val?.crewYardName,
        finish_crew_yard_name: crewYardListing?.find(
          (yard) => yard.id === val?.crewYardName
        )?.name,
        finish_point_duration: decimalHours,
        is_changing_start_point: false,
        finish_crew_yard_latitude: "24.9002608",
        finish_crew_yard_longitude: "67.0732217",
      };
    }
    changeStartOrEndPoint(payload)
      .then(() => {
        const formattedDate = dayjs(selectedDate).format("YYYY-MM-DD");
        dispatch(getScheduleByDay(formattedDate));
        SuccessMessage(`${isStartPoint ? "Start" : "Finish"} point updated`);
        onCloseHandler();
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    if (crewYardListing) {
      console.log("crewYardListing", crewYardListing);
      const crewYardOptions = crewYardListing.map((yard) => ({
        label: yard?.name,
        value: yard?.id,
      }));
      setCrewYardDropOptions(crewYardOptions);
    }
  }, [crewYardListing]);
  return (
    <Form
      layout="vertical"
      onFinish={handleSubmit(onSubmit)}
      onKeyDown={(e) => {
        if (e.key === "Enter") e.preventDefault();
      }}
    >
      <Row gutter={16}>
        <Col span={16}>
          <SelectField
            fieldName="crewYardName"
            label="Crew yard name"
            control={control}
            selectOption={crewYardDropOptions}
            iProps={{
              placeholder: "Select Crew yard name",
            }}
            isRequired
            rules={{
              required: "Crew yard name is required.",
            }}
            validate={errors.crewYardName && "error"}
            validMessage={
              typeof errors.crewYardName?.message === "string"
                ? errors.crewYardName.message
                : undefined
            }
            tooltipTitle="Crew yard name"
          />
        </Col>
        <Col span={8}>
          <TimePickerField
            fieldName="allocatedTime"
            label="Allocated time"
            control={control}
            isRequired
            rules={{
              required: "Allocated time is required.",
            }}
            validate={errors.allocatedTime && "error"}
            validMessage={
              typeof errors.allocatedTime?.message === "string"
                ? errors.allocatedTime.message
                : undefined
            }
            tooltipTitle="Allocated Time"
          />
        </Col>
      </Row>

      <div className="modal_footer">
        <Button
          htmlType="button"
          className="outlined-btn"
          type="default"
          size="large"
          onClick={onCloseHandler}
        >
          Cancel
        </Button>

        <Button
          htmlType="submit"
          className="mint-btn"
          type="primary"
          size="large"
        >
          Save changes
        </Button>
      </div>
    </Form>
  );
};

export default CrewYard;
